@use "../../styles/variables" as vars;

.wrapper {
  width: min(100%, 180px);
  margin-inline: auto;
}

.steps {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0;
  margin: 0;
  list-style: none;
}

.step {
  position: relative;
  width: 44px;
  height: 3px;
  overflow: hidden;
  border-radius: 999px;
}

.base,
.fill {
  position: absolute;
  inset: 0;
  display: block;
  border-radius: inherit;
}

.base {
  background: #a6a6a6;
}

.fill {
  right: auto;
  background: vars.$color-secondary;
}
